import { GenericObject, copyFields } from '@synergy/models';
import { Media } from '@synergy/models';

import { ProductSnapshot } from '../../../common/models/product-snapshot';

export class PurchaseOrderProductItem extends ProductSnapshot {
    public id?: number;
    public position?: number;
    /** Documents and pictures filed on this position (#2187). */
    public media: Media[] = [];

    public static fromPlainObject(object: GenericObject): PurchaseOrderProductItem {
        const purchaseOrderItem = new PurchaseOrderProductItem();

        // Import own keys
        copyFields(object, purchaseOrderItem);

        // Import from base class (snapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite intersecting keys with base keys
        copyFields(productSnapshot, purchaseOrderItem);

        return purchaseOrderItem;
    }
}
